export const SEEDDATA_GROUP_TEAM_A = 'team-a';
export const SEEDDATA_GROUP_TEAM_B = 'team-b';
export const SEEDDATA_GROUP_TEAM_X = 'team-x';
export const SEEDDATA_GROUP_TEAM_USER_FOO = 'user-foo';
export const SEEDDATA_GROUP_TEAM_USER_BAR = 'user-bar';
export const SEEDDATA_GROUP_TEAM_A_ID = 'IDGROUP_team-a';
export const SEEDDATA_GROUP_TEAM_B_ID = 'IIDGROUP_team-b';
export const SEEDDATA_GROUP_TEAM_X_ID = 'IDGROUP_team-x';
export const SEEDDATA_GROUP_TEAM_USER_FOO_ID = 'IDGROUP_user-foo';
export const SEEDDATA_GROUP_TEAM_USER_BAR_ID = 'IDGROUP_user-bar';
export const SEEDDATA_AVATAR_URLS_MIA = {
    '48x48': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Zoey',
    '24x24': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Zoey',
    '16x16': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Zoey',
    '32x32': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Zoey',
};
export const SEEDDATA_AVATAR_URLS_BOB = {
    '48x48': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Whiskers',
    '24x24': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Whiskers',
    '16x16': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Whiskers',
    '32x32': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Whiskers',
};
export const SEEDDATA_AVATAR_URLS_ADMIN = {
    '48x48': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Dusty',
    '24x24': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Dusty',
    '16x16': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Dusty',
    '32x32': 'https://api.dicebear.com/5.x/avataaars/svg?seed=Dusty',
};
export const SEEDDATA_ACCOUNT_ID_MIA = 'mia5b10a2844c20165700ede21g';
export const __rest__api__3__myself___TESTID_MIA = {
    key: '',
    accountId: SEEDDATA_ACCOUNT_ID_MIA,
    name: 'mia',
    emailAddress: 'mia@example.com',
    avatarUrls: SEEDDATA_AVATAR_URLS_MIA,
    displayName: 'Mia Krystof',
    active: true,
    timeZone: 'Australia/Sydney',
    groups: {
        size: 1,
        items: [{ self: SEEDDATA_GROUP_TEAM_A, name: SEEDDATA_GROUP_TEAM_A, groupId: SEEDDATA_GROUP_TEAM_A_ID }],
    },
    applicationRoles: {
        size: 0,
        items: [],
    },
};
export const SEEDDATA_ACCOUNT_ID_BOB = 'bob1b10a2844c20165700ede42ff';
export const __rest__api__3__myself___TESTID_BOB = {
    key: '',
    accountId: SEEDDATA_ACCOUNT_ID_BOB,
    name: 'bob',
    emailAddress: 'bob@example.com',
    avatarUrls: SEEDDATA_AVATAR_URLS_BOB,
    displayName: 'Bob Bobbers',
    active: true,
    timeZone: 'Germany/Berlin',
    groups: {
        size: 2,
        items: [
            { self: SEEDDATA_GROUP_TEAM_X, name: SEEDDATA_GROUP_TEAM_X, groupId: SEEDDATA_GROUP_TEAM_X_ID },
            { self: SEEDDATA_GROUP_TEAM_USER_FOO, name: SEEDDATA_GROUP_TEAM_USER_FOO, groupId: SEEDDATA_GROUP_TEAM_USER_FOO_ID },
        ],
    },
    applicationRoles: {
        size: 0,
        items: [],
    },
};
export const SEEDDATA_ACCOUNT_ID_ADMIN = 'XXX-YYY-ZZZ';
export const __rest__api__3__myself___TESTID_ADMIN = {
    key: '',
    accountId: SEEDDATA_ACCOUNT_ID_ADMIN,
    name: 'admin',
    emailAddress: 'admin@example.com',
    avatarUrls: SEEDDATA_AVATAR_URLS_ADMIN,
    displayName: 'Admin Adminster',
    active: true,
    timeZone: 'Germany/Berlin',
    groups: {
        size: 0,
        items: [],
    },
    applicationRoles: {
        size: 0,
        items: [],
    },
};
export const MOCKED__DTOUserWithGroups__MIA = {
    name: 'Mia Krystof',
    accountId: SEEDDATA_ACCOUNT_ID_MIA,
    emailAddress: 'mia@example.com',
    locale: undefined,
    timeZone: 'Australia/Sydney',
    avatarUrls: SEEDDATA_AVATAR_URLS_MIA,
    displayName: 'Mia Krystof',
    groups: {
        size: 1,
        items: [{ groupName: SEEDDATA_GROUP_TEAM_A, groupId: SEEDDATA_GROUP_TEAM_A_ID }],
    },
};
